<div class="negotiations-container">
  <div class="negotiations-content">
    <span class="title">{{ 'commission.new.negotiation_rules' | translate }}</span>
    <div class="desc-container">
      <img src="assets/icones/info.svg" alt="" />
      <div class="secondary-text">
        {{ 'commission.new.negotiation_rules_desc' | translate }}
      </div>
    </div>
    <hr />
    <form [formGroup]="negotiationForm" class="negotiations-form">
      <div *ngIf="negotiations.controls.length" formArrayName="negotiations" class="negotiations-array" #negotiationsArray>
        <div *ngFor="let negotiation of negotiations.controls; let i = index" [formGroupName]="i" class="negotiations-input">
          <div class="standard-input has-icon">
            <label for="min_extra_discount">{{ 'commission.new.min_extra_discount' | translate }}</label>
            <div class="input-container">
              <input type="number" formControlName="min_extra_discount" [placeholder]="'eg. ' + (i === 0 ? 0 : i * 5 + 1)" (input)="onInputRemoveLeadingZero($event, negotiation, 'min_extra_discount')"/>
              <span class="btn-icon" style="cursor: default">
                <app-svg-icon svgIcon="percentage-cc"></app-svg-icon>
              </span>
            </div>
            <!-- Control errors -->
            <div class="error" *ngIf="negotiation.get('min_extra_discount')?.invalid && (negotiation.get('min_extra_discount')?.touched || negotiation.get('min_extra_discount')?.dirty)">
              <small *ngIf="negotiation.get('min_extra_discount')?.hasError('required')">{{ "validation.required" | translate }}</small>
              <small *ngIf="negotiation.get('min_extra_discount')?.hasError('min')">{{
                "validation.min" | translate : { min: negotiation.get("min_extra_discount")?.getError("min").min }
              }}</small>
              <small *ngIf="negotiation.get('min_extra_discount')?.hasError('max')">{{
                "validation.max" | translate : { max: negotiation.get("min_extra_discount")?.getError("max").max }
              }}</small>
            </div>
            <!-- Group error -->
            <div class="error" *ngIf="negotiation.hasError('rangeInvalid') && (negotiation.get('min_extra_discount')?.touched || negotiation.get('min_extra_discount')?.dirty)">
              <small>
                {{ 'validation.range_less' | translate: { field1: 'Min', field2: 'Max' } }}
              </small>
            </div>
          </div>
          <div class="standard-input has-icon">
            <label for="max_extra_discount">{{ 'commission.new.max_extra_discount' | translate }}</label>
            <div class="input-container">
              <input type="number" formControlName="max_extra_discount" [placeholder]="'eg. ' + (i === 0 ? 5 : i * 5 + 5)" (input)="onInputRemoveLeadingZero($event, negotiation, 'max_extra_discount')"/>
              <span class="btn-icon" style="cursor: default">
                <app-svg-icon svgIcon="percentage-cc"></app-svg-icon>
              </span>
            </div>
            <!-- Control errors -->
            <div class="error" *ngIf="negotiation.get('max_extra_discount')?.invalid && (negotiation.get('max_extra_discount')?.touched || negotiation.get('max_extra_discount')?.dirty)">
              <small *ngIf="negotiation.get('max_extra_discount')?.hasError('required')">{{ "validation.required" | translate }}</small>
              <small *ngIf="negotiation.get('max_extra_discount')?.hasError('min')">{{
                "validation.min" | translate : { min: negotiation.get("max_extra_discount")?.getError("min").min }
              }}</small>
              <small *ngIf="negotiation.get('max_extra_discount')?.hasError('max')">{{
                "validation.max" | translate : { max: negotiation.get("max_extra_discount")?.getError("max").max }
              }}</small>
            </div>
            <!-- Group error -->
            <div class="error" *ngIf="negotiation.hasError('rangeInvalid') && (negotiation.get('max_extra_discount')?.touched || negotiation.get('max_extra_discount')?.dirty)">
              <small>
                {{ 'validation.range_greater' | translate: { field1: 'Max', field2: 'Min' } }}
              </small>
            </div>
          </div>
          <div class="standard-input has-icon">
            <label for="new_commission">{{ 'commission.new.new_commission' | translate }}</label>
            <div style="display: flex; align-items: center; gap: 10px">
              <div class="input-container" style="flex: 1">
                <input type="number" formControlName="new_commission" min="0" max="100" (input)="onInputRemoveLeadingZero($event, negotiation, 'new_commission')"/>
                <span class="btn-icon" style="cursor: default">
                  <app-svg-icon svgIcon="percentage-cc"></app-svg-icon>
                </span>
              </div>
              <button
                type="button"
                class="action-btn secondary-btn icon-btn"
                style="flex: none"
                style="border-color: #970000"
                (click)="removeNegotiation(i)"
              >
                <span class="icon" style="color: #970000">
                  <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
                </span>
              </button>
            </div>
            <div
              class="error"
              *ngIf="
                negotiation.get('new_commission')?.invalid && (negotiation.get('new_commission')?.touched || negotiation.get('new_commission')?.dirty)
              "
            >
              <small *ngIf="negotiation.get('new_commission')?.hasError('required')">{{ "validation.required" | translate }}</small>
              <small *ngIf="negotiation.get('new_commission')?.hasError('min')">{{ "validation.min" | translate : { min: 0 } }}</small>
              <small *ngIf="negotiation.get('new_commission')?.hasError('max')">{{ "validation.max" | translate : { max: 100 } }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="add-negotiation-action">
        <button class="action-btn clear-btn" style="color: #6449DB" (click)="addNegotiation()" *ngIf="lastNegotationMaxValue < 100">
          <span class="icon"><app-svg-icon svgIcon="plus-cc"></app-svg-icon></span>
          {{ 'commission.actions.add_rule' | translate }}
        </button>
      </div>
    </form>
  </div>
  <div class="actions">
    <button type="button" class="action-btn secondary-btn" (click)="previous()">
      <span class="icon">
        <img src="assets/icones/arrow-back-black.svg" alt="" />
      </span>
      {{ "agent.actions.back" | translate }}
    </button>
    <button type="button" class="action-btn primary-btn" (click)="next()">
      {{ "agent.actions.proceed" | translate }}
      <span class="icon">
        <img src="assets/icones/arrow-right.svg" alt="" />
      </span>
    </button>
  </div>
</div>
